// const CARISOK_CONFIG_SESSIONSTORAGE = 'CARISOK_CONFIG_SESSIONSTORAGE'

/**
 * CARISOK_CONFIG_SESSIONSTORAGE
 */
import _ from 'lodash'
const firstPage = 'FIRST_PAGE'
const historyStack = 'HISTORY_STACK'

export const getLocalConfig = name => {
    try {
        return JSON.parse(sessionStorage.getItem(name)) || ''
    } catch (err) {
        return ''
    }
}

export const setLocalConfig = (name, config) => {
    try {
        sessionStorage.setItem(name, JSON.stringify(config))
    } catch (err) {
        sessionStorage.setItem(name, '')
    }
}

export const removeLocalConfig = name => {
    try {
        sessionStorage.removeItem(name)
    } catch (err) {
        sessionStorage.removeItem(name)
    }
}

/**
 * 记录访问的第一个Path 到sessionStorage，便于授权登录成功返回
 */
export const setFirstPage = path => {
    sessionStorage.setItem(firstPage, JSON.stringify(path))
}
/**
 * 返回访问的第一个Path 到sessionStorage，便于授权登录成功返回
 */
export const getFirstPage = () => {
    try {
        let page = JSON.parse(sessionStorage.getItem(firstPage))
        if (page.path === '/login' || !page || _.isEmpty(page)) {
            page = {
                path: '/'
            }
        }
        return page
    } catch (err) {
        return {
            path: '/'
        }
    }
}
/**
 * 将历史记录栈保存到 sessionStorage，以便用户刷新之后，程序能够得知历史记录信息
 * @param stacks 历史记录栈
 */
export const setHistoryStack = (stacks = []) => {
    const resolvedStacks = _.map(stacks, route => {
        return _.pick(route, ['name', 'meta', 'path', 'hash', 'fullPath'])
    })

    sessionStorage.setItem(historyStack, JSON.stringify(resolvedStacks))
}

/**
 * 尝试用 sessionStorage 获取历史记录信息
 */
export const getHistoryStack = () => {
    return JSON.parse(sessionStorage.getItem(historyStack) || '[]')
}
